import { useEffect, useState } from "react";
import { Card } from "reactstrap";
import { useDeviceLocation } from "../../hooks/utilityHooks";

const UserLocationSelect = () => {
  const { location, getLocation, addEventListener, eventTypes } =
    useDeviceLocation(true);

  useEffect(() => {
    addEventListener(eventTypes.retrivedLocation, (e) => {
      console.log("location retrived successfull", e?.detail);
    });
    addEventListener(eventTypes.getLocation, () =>
      console.log("gettiong location")
    );
    addEventListener(eventTypes.errorLocation, (e) =>
      console.log("error occured while getting location", e?.detail)
    );
    addEventListener(eventTypes.locationOn, () => {
      console.log("user turned on location");
      getLocation();
    });
    addEventListener(eventTypes.locationOff, () =>
      console.log("user turned off location")
    );
  }, []);

  return (
    <Card className="location-card cursor-pointer mb-1_5rem">
      <div
        className="rounded-full d-flex align-items-center justify-content-center"
        style={{
          height: 25,
          width: 25,
          border: "1.28px solid rgba(209, 209, 209, 1)",
        }}
      >
        <div
          className="rounded-full bg-primary-blue"
          style={{ height: 15, width: 15 }}
        ></div>
      </div>
      <h6 className="m-0 f-4 color-primary-blue">You ({location?.longitude} , {location?.latitude})</h6>
    </Card>
  );
};

export default UserLocationSelect;
